import { render } from "./ChanceMakeQuote.vue?vue&type=template&id=06e987ba&scoped=true"
import script from "./ChanceMakeQuote.vue?vue&type=script&lang=js"
export * from "./ChanceMakeQuote.vue?vue&type=script&lang=js"

import "./ChanceMakeQuote.vue?vue&type=style&index=0&id=06e987ba&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e987ba"]])

export default __exports__